<script lang="ts">
  import { appState } from '../store/appState.svelte.ts'

  import { gotoBack } from '../routes.svelte.ts'

  import AppSideMenuAdd from './AppSideMenuAdd.svelte'
  import AppSideMenuMain from './AppSideMenuMain.svelte'
  import ZSyncIndicator from './ZSyncIndicator.svelte'

  import ZIcon from './ZIcon.svelte'
  import NuIconChevronLeft from './icons/NuIconChevronLeft.svelte'
  import NuIconMenu from './icons/NuIconMenu.svelte'
  import NuIconPlus from './icons/NuIconPlus.svelte'

  // -------------------------------------------------------------------

  let showMainMenu = $state(false)
  let showAddMenu = $state(false)

  // -------------------------------------------------------------------

  function openMainMenu (): void {
    showMainMenu = true
  }

  // -------------------------------------------------------------------

  function closeMainMenu (): void {
    showMainMenu = false
  }

  // -------------------------------------------------------------------

  function openAddMenu (): void {
    showAddMenu = true
  }

  // -------------------------------------------------------------------

  function closeAddMenu (): void {
    showAddMenu = false
  }

  function handleBack (): void {
    gotoBack()
  }
</script>

<!-- ------------------------------------------------------------- -->

<header
  class="a-app-header bg-foreground max-mobile:p-0.5 max-mobile:[&_.z-icon]:size-6 [&_.z-icon:hover]:text-primary flex
    flex-row p-4 text-white [&_.z-icon]:text-white">
  <div class="flex grow flex-row items-center gap-2">
    {#if appState.isReadyForAction}
      <ZIcon icon={NuIconChevronLeft} onclick={handleBack} />
      <ZSyncIndicator />
    {/if}
  </div>

  <div class="nux-title nu-center-content nu-center-horz nu-overflow-shrink-ellipsis flex grow items-center">
    <!-- This is a Teleport target/anchor, to be used by AppTitle.
         When empty, show default title (the default-title div).
         This 'weird' css construction is well supported in any modern browser from the last decade. -->
    <div id="app-header-title" class="[&:not(:empty)~.default-title]:hidden"></div>
    <div class="default-title flex items-center">
      <h1 class="flex translate-y-[2px] items-center">Peanutz</h1>
    </div>
  </div>

  <div class="a-app-header-area-right flex grow items-center justify-end [&_.z-icon:last-child]:mr-2">
    {#if appState.isReadyForAction}
      <div class="flex flex-row gap-2">
        <ZIcon class="a-app-header-add-menu" icon={NuIconPlus} onclick={openAddMenu} />
        <ZIcon class="a-app-header-main-menu-toggle" icon={NuIconMenu} onclick={openMainMenu} />
      </div>
    {/if}
  </div>
</header>

{#if showMainMenu}
  <AppSideMenuMain onClose={closeMainMenu} />
{/if}

{#if showAddMenu}
  <AppSideMenuAdd onClose={closeAddMenu} />
{/if}

<!-- ------------------------------------------------------------- -->

<style lang="stylus">
.a-app-header
  display grid
  grid-template-columns 1fr auto 1fr
</style>
